module.exports = __webpack_public_path__ + "static/media/Meera Ramachandran.9f40397f.png";